import { useState } from 'react'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'
import { AvailableModules } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { UpsellSalesInvoiceFeatureModal } from 'modules/project_management/components/upsells/UpsellSalesInvoiceFeatureModal'

interface UpsellProp {
  projectsMissing: boolean
}

export const UpsellProjectInvoices = ({ projectsMissing }: UpsellProp) => {
  const [upsellRequested, setUpsellRequested] = useState(false)
  const handleOnCloseUpsellModal = () => {
    setUpsellRequested(false)
  }

  return (
    <Box
      alignItems="center"
      textAlign="center"
      gap="s16"
      paddingX="s400"
      paddingY="s120"
      justifyContent="center"
    >
      <Icon.Large icon="fireworks" />
      <Text weight="medium" size="300" color="grey1000">
        {i18n.t('packaging.upgrade_plan.title')}
      </Text>
      <Box alignItems="center" gap="s16">
        <Text size="300" color="grey800">
          {i18n.t('project_management.sale_invoices.upselling.message')}
        </Text>
        <Button aria-label="Click me" onClick={() => setUpsellRequested(true)} type="upgrade">
          {i18n.t('pricing_plans.submit_button.no_plan')}
        </Button>
      </Box>
      {upsellRequested && (
        <UpsellSalesInvoiceFeatureModal
          onClose={handleOnCloseUpsellModal}
          moduleRequested={projectsMissing ? AvailableModules.projects : AvailableModules.sales}
          originProjects
        />
      )}
    </Box>
  )
}
